import {
    EmailOptInRepository,
    IEmailOptInPayload
} from '../internal/repositories/EmailOptInRepository';
import {
    IPayload,
    UserProfileChangedUseCase
} from '../internal/use-cases/UserProfileChangedUseCase';
import { EmailOptInRequestUseCase } from '../internal/use-cases/EmailOptInRequestUseCase';
import { ClearEmailOptInUseCase } from '../internal/use-cases/ClearEmailOptInUseCase';
import { diContainer } from './diContainer';
import serviceNames from '~setup/CommunicationsService';
import { ProductNotifyMeRequestUseCase } from '../internal/use-cases/ProductNotifyMeRequestUseCase';

interface IProductNotifyMeRequestData {
    context?: string;
    skuId: string;
    email: string;
    subscriptionType: string;
    skuBaseId: string;
}

export type IProductNotifyMeRequestSuccessData = IProductNotifyMeRequestData;

interface IProductNotifyMetRequestFailureData extends IProductNotifyMeRequestData {
    error?: string;
}

export class ServiceBusController {
    private emailOptInRepository: EmailOptInRepository;

    constructor() {
        this.emailOptInRepository = diContainer.get(serviceNames.emailOptInRepository);
    }

    public emailOptInRequestFromAccount = async (payload: IEmailOptInPayload) => {
        const emailOptInRequestUseCase = new EmailOptInRequestUseCase(payload);
        await emailOptInRequestUseCase.execute();
    };

    public emailOptInRequest = async (payload: IEmailOptInPayload) => {
        const emailOptInRequestUseCase = new EmailOptInRequestUseCase(payload);
        await emailOptInRequestUseCase.execute();
    };

    public appointmentBookedEmailOptInRequest = async (payload: IEmailOptInPayload) => {
        const emailOptInRequestUseCase = new EmailOptInRequestUseCase(payload);
        await emailOptInRequestUseCase.execute();
    };

    public guestEmailOptInRequest = async (payload: IEmailOptInPayload) => {
        const emailOptInRequestUseCase = new EmailOptInRequestUseCase(payload);
        await emailOptInRequestUseCase.execute();
    };

    public userProfileChanged = async (userProfile: IPayload) => {
        const userProfileChangedUseCase = new UserProfileChangedUseCase(userProfile);
        await userProfileChangedUseCase.execute();
    };

    public clearEmailOptIn = () => {
        const clearEmailOptInRequestUseCase = new ClearEmailOptInUseCase();
        clearEmailOptInRequestUseCase.execute();
    };

    public onProductNotifyMeRequest = (e: IProductNotifyMeRequestData) => {
        const useCase = new ProductNotifyMeRequestUseCase({ ...e });
        void useCase.execute();
    };

    public onProductNotifyMeRequestFailure = (e: IProductNotifyMetRequestFailureData) => {
        console.warn(e);
    };

    public emailSignUp = () => {
        return this.emailOptInRepository.emailOptIn;
    };
}
